import { Link } from '@tanstack/react-router';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ChevronRight, User } from 'lucide-react';

const getStatusVariant = status => {
    switch (status) {
        case 'COMPLETED':
            return 'completed';
        case 'ACTIVE':
        case 'IN_PROGRESS':
            return 'active';
        case 'NOT COMPLETED':
        case 'PENDING':
            return 'not_completed';
        default:
            return 'default';
    }
};

const CohortCard = ({ cohort }) => {
    return (
        <div className="w-full border border-neutral-300 rounded-lg p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2">
            <div className="grow w-full">
                <h3 className="flex flex-col justify-start line-clamp-2 min-h-25">
                    {cohort.cohort_name} - {cohort.course_name}
                </h3>
                <div className="flex items-center justify-start gap-2 mt-2">
                    <Badge variant={getStatusVariant(cohort.status)} className="px-3 uppercase">
                        {cohort.status}
                    </Badge>
                    <strong className="text-sm text-neutral-700 flex gap-2  justify-center items-center">
                        <User /> Mentor: {cohort.technical_mentor_first_name} {cohort.technical_mentor_last_name}
                    </strong>
                </div>
                <div className="flex flex-col gap-2 mt-4 mb-1 w-full">
                    <strong className="text-sm font-bold uppercase text-success">{cohort.total_points} Points</strong>
                    <div className="w-full bg-neutral-200 rounded-full h-2.5  overflow-hidden mb-2">
                        <div
                            className="text-success h-2.5 rounded-full transition-all"
                            style={{
                                width: `${Math.min(100, Math.max(0, (cohort.total_points / (cohort.course_score || 1)) * 100))}%`,
                            }}
                        ></div>
                    </div>
                    <div className="text-sm text-neutral-700 ">
                        {(() => {
                            const startDate = new Date(cohort.start_date);
                            const endDate = new Date(cohort.end_date);
                            const today = new Date();

                            const totalMilliseconds = endDate - startDate;
                            const totalWeeks = Math.ceil(totalMilliseconds / (1000 * 60 * 60 * 24 * 7));

                            const elapsedMilliseconds = today - startDate;
                            const elapsedWeeks = Math.floor(elapsedMilliseconds / (1000 * 60 * 60 * 24 * 7));

                            // Cap elapsed weeks so UI never shows more weeks than total duration
                            const cappedElapsedWeeks = Math.min(Math.max(0, elapsedWeeks), Math.max(0, totalWeeks));

                            return (
                                <p className="flex flex-row gap-1">
                                    <span className="font-bold">
                                        {cappedElapsedWeeks} out of {totalWeeks}
                                    </span>{' '}
                                    weeks completed
                                </p>
                            );
                        })()}
                    </div>
                    <p className="">
                        <span className="font-bold">{cohort.course_score} points</span> required for completion
                    </p>
                </div>

                <div className="mt-2 w-full ">
                    {/* local dev */}

                    {/* 
                    <Link to={`/progress-details/${cohort.cohort_id}`} className="w-full">
                        <Button
                        variant={"outline"}
                        className="w-full text-primary border-primary hover:bg-primary hover:text-neutral-50 flex items-center justify-center gap-2"
                        >
                        View Progress <ChevronRight />
                        </Button>
                    </Link> 
                    */}

                    {/* prod */}
                    <Link to="/coming-soon" preload="intent" preloadDelay={0} className="w-full">
                        <Button variant={'outline'} className="w-full flex items-center justify-center gap-2">
                            View Progress <ChevronRight />
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CohortCard;
